import { useEffect, useState, useCallback, useRef } from 'react';
import tagsService from '@/services/setting/tagsService';
import userService from '@/services/setting/userService';
import { useAbility } from '@/providers/';
import { KeenIcon } from '@/components';
import { useNavigate } from 'react-router-dom';
import { useToolbar } from '@/providers/ToolbarProvider';
import DataTable from 'datatables.net-react';
import DT from 'datatables.net-dt';
import 'datatables.net-select-dt';
import 'datatables.net-responsive-dt';
import { createRoot } from 'react-dom/client';
import { SelectInput, DateInput, TextInput, STATUS_OPTIONS, STATUS_NUMBER_OPTIONS, FilterContainer } from '@/components/TableFilter'
import { cn } from '@/lib/utils';
import { FiltersToFormData, getAccessToken, renderMultiAvatars } from '@/utils';
import { createDataTableOptions, createDataTableConfig } from '@/utils';
import { useAuthContext } from '@/auth';
import { goTo403 } from "@/utils/Navigation";
import { Exporter } from '../../exporter';
import { ColumnToggleDropdown } from '../../TableFilter/ColumnToggleDropdown';
import contactService from '@/services/contact/contactTypeService';
import { useContactTypeOptions, useUserOptions, useTagOptions } from '@/hooks'

DataTable.use(DT);
const Contacts = ({ onNavigateFromChild }) => {
    const { logout } = useAuthContext();
    const { ability } = useAbility();
    const Navigate = useNavigate()
    const { setConfig } = useToolbar();
    const [showFilter, setShowFilter] = useState(false)
    const [filterData, setFilterData] = useState({
        created_by: null,
        assigned_to: null,
        status: null,
        created_at: null,
        allow_secure_messaging: null,
        tags: null,
        from_date: null,
        to_date: null,
        date_range: null,
        state: null,
        zip: null,
        // matter_id: matterID,
        id: null,
        contact_type: null
    });

    const tableRef = useRef(null);
    const API_URL = import.meta.env.VITE_APP_BASE_URL;
    const token = getAccessToken();
    const filterRef = useRef(filterData);
    const loadContactTypeOptions = useContactTypeOptions({ defaultPageSize: 20 });
    const loadUserOptions = useUserOptions({ defaultPageSize: 20 });
    const loadTagOptions = useTagOptions({ defaultPageSize: 20 });


    useEffect(() => {
        filterRef.current = filterData;
    }, [filterData]);

    const columns = [
        // {
        //     title: 'S#',
        //     name: 'serial',
        //     data: null,
        //  orderable: true,se,
        //     render: (data, type, row, meta) => meta.row + 1,
        // },
        {
            title: 'Name',
            data: 'fullName',
            name: 'fullName',
            orderable: true,
            render: function (data, type, row) {
                return `<div id="contact-cell-${row.id}"></div>`;
                // return `<span>${row.first_name} ${row.last_name}</span>`;
            }
        },
        { data: 'email', name: 'email', title: 'Email' },
        {
            title: 'Contact Type',
            name: 'contact_type',
            data: 'contact_type.name',
            render: value => (value ? value : '-'),
            defaultContent: '-',
            orderable: false
        },
        {
            title: 'Invoices',
            data: 'invoices',
            name: 'invoices',
            orderable: false,
            render: function (data, type, row) {
                return `<div id="invoice-cell-${row.id}"></div>`;
                // return `<span>${row.first_name} ${row.last_name}</span>`;
            }
        },
        {
            title: 'Invoices Total',
            data: 'invoices_total',
            name: 'invoices_total',
            orderable: false,
            // render: function (data, type, row) {
            //     return `$${row.invoices_total}`
            // }
            render: function (data, type, row) {
                return `<div id="invoice-total-cell-${row.id}"></div>`;
            }
        },
        {
            title: 'Matters',
            data: 'matters_count',
            name: 'matters_count',
            orderable: false,
            render: function (data, type, row) {
                return `<div id="matter-cell-${row.id}"></div>`;
            }
        },
        {
            data: 'tags',
            name: 'tags',
            title: 'Tags',
            className: 'whitespace-normal',
            orderable: true,
            render: function (data, type, row) {
                if (!Array.isArray(data)) return '';
                const tagSpans = data
                    .map(tag => `<span class="capitalize whitespace-nowrap badge badge-pill badge-outline badge-primary mr-1 mb-1">${tag.name}</span>`)
                    .join('');
                return tagSpans;
            }
        },
        {
            data: 'status',
            name: 'status',
            title: 'Status',
            orderable: true,
            render: function (value) {
                const badgeClass = value === 'active' ? 'badge-success' : 'badge-danger';
                const label = value === 'active' ? 'Active' : 'Inactive';
                return `<span class="badge badge-pill badge-outline ${badgeClass} gap-1 items-center">
            <span class="badge badge-dot size-1.5 ${badgeClass}"></span>
            ${label}
          </span>`
            }
        },
        {
            data: 'allow_secure_messaging',
            name: 'allow_secure_messaging',
            title: 'Secure Messaging',
            orderable: true,
            render: function (value) {
                const badgeClass = value === 0 ? 'badge-danger' : 'badge-success';
                const label = value === 0 ? 'Disabled' : 'Enabled';
                return `
          <span class="badge badge-pill badge-outline ${badgeClass} gap-1 items-center">
            <span class="badge badge-dot size-1.5 ${badgeClass}"></span>
            ${label}
          </span>`

            }
        },
        {
            title: 'Assigned To',
            name: 'assigned_to',
            data: 'assigned_to',
            orderable: true,
            searchable: false,
            render: function (data, type, row) {
                return `<div id="assigned-to-${row.id}"></div>`;
            }
        },
        // {
        //     title: 'Created By',
        //     name: 'created_by',
        //     data: 'created_by',
        //     render: value => (value ? value.name : '-'),
        //     orderable: true,
        //     defaultContent: '-',
        // },
        {
            orderable: true, title: 'Created At', name: 'created_at', data: 'created_at',
            defaultContent: '-'
        },
    ];

    const defaultVisibleColumns = [
        // 'serial',
        'fullName',
        'email',
        'contact_type',
        'invoices',
        'invoices_total',
        'matters_count',
    ]

    const ajaxConfig = createDataTableConfig('/contacts/data_table_list?has[invoices]=1', filterRef, token, logout);

    const options = createDataTableOptions({
        order: [[0, 'desc']],
        initComplete: function () {
            const api = this.api();
            api.columns().every(function () {
                const col = this;
                const name = col.settings()[0].aoColumns[col.index()].name;
                if (name && !defaultVisibleColumns.includes(name)) {
                    col.visible(false);
                }
            });
        },
        drawCallback: function () {
            const api = this.api();
            const rows = api.rows({ page: 'current' }).data();

            rows.each((row) => {
                const container = document.getElementById(`assigned-to-${row.id}`);
                if (container) {
                    if (!container._reactRoot) {
                        container._reactRoot = createRoot(container);
                    }
                    container._reactRoot.render(renderMultiAvatars(row.assigned_to));
                }
                const contactContainer = document.getElementById(`contact-cell-${row.id}`);
                if (contactContainer) {
                    if (!contactContainer._reactRoot) {
                        contactContainer._reactRoot = createRoot(contactContainer);
                    }
                    contactContainer._reactRoot.render(renderContactName(row));
                }

                const invoiceContainer = document.getElementById(`invoice-cell-${row.id}`);
                if (invoiceContainer) {
                    if (!invoiceContainer._reactRoot) {
                        invoiceContainer._reactRoot = createRoot(invoiceContainer);
                    }
                    invoiceContainer._reactRoot.render(renderInvoiceNumber(row));
                }

                const matterContainer = document.getElementById(`matter-cell-${row.id}`);
                if (matterContainer) {
                    if (!matterContainer._reactRoot) {
                        matterContainer._reactRoot = createRoot(matterContainer);
                    }
                    matterContainer._reactRoot.render(renderMatterNumber(row));
                }

                const invoiceTotalContainer = document.getElementById(`invoice-total-cell-${row.id}`);
                if (invoiceTotalContainer) {
                    if (!invoiceTotalContainer._reactRoot) {
                        invoiceTotalContainer._reactRoot = createRoot(invoiceTotalContainer);
                    }
                    invoiceTotalContainer._reactRoot.render(renderInvoiceTotal(row));
                }

            });
        },
    });

    const resetFilters = () => {
        const cleared = {
            created_by: null,
            assigned_to: null,
            status: null,
            created_at: null,
            allow_secure_messaging: null,
            tags: null,
            from_date: null,
            to_date: null,
            date_range: null,
            state: null,
            zip: null,
            // matter_id: matterID,
            id: null,
        };

        setFilterData(cleared);
        filterRef.current = cleared;
        refresh()
    };

    const handleFilterChange = (key, val) => {
        setFilterData((prev) => {
            const updated = { ...prev, [key]: val };
            filterRef.current = updated;
            //console.log('updated',updated)
            return updated;
        });
    };

    const handleToggleFilter = () => {
        setShowFilter(prev => !prev)
    }

    const refresh = () => {
        const table = tableRef.current.dt();
        table.ajax.reload();
    };

    const renderContactName = (row) => {
        const fullName = row.fullName;
        const { id } = row;
        return (
            <span onClick={() => { handleNavigateConatct(id) }} className='cursor-pointer link'>{fullName}</span>
        )
    }

    const renderInvoiceNumber = (row) => {
        const { invoices } = row
        if (!Array.isArray(invoices) || invoices.length === 0) return <span>-</span>;

        return (
            <div className="flex flex-wrap gap-2">
                <span className="cursor-pointer link"
                    onClick={() => {
                        onNavigateFromChild?.(
                            "Invoices",
                            {
                                invoices,
                                contactId: row.id,
                                contactName: row.first_name + " " + row.last_name
                            }
                        );
                    }}
                >
                    {invoices.length} {invoices.length === 1 ? 'Invoice' : 'Invoices'}
                </span>
            </div>
        );
    }

    const renderInvoiceTotal = (row) => {
        const { invoices } = row;
        if (!Array.isArray(invoices) || invoices.length === 0) return <span>-</span>;

        // Convert all totals to numbers and sum them
        const mergedTotal = invoices.reduce((sum, group) => {
            const val = Math.round(Number(group.total) * 100); // convert to cents
            return sum + val;
        }, 0);

        return <span>${(mergedTotal / 100).toFixed(2)}</span>;
    };

    const renderMatterNumber = (row) => {
        const { matters } = row
        if (!Array.isArray(matters) || matters.length === 0) return <span>-</span>;

        return (
            <div className="flex flex-wrap gap-2">
                <span className="cursor-pointer link"
                    onClick={() => {
                        onNavigateFromChild?.(
                            "Matters",
                            {
                                matters,
                                contactId: row.id,
                                contactName: row.first_name + " " + row.last_name
                            }
                        );
                    }}
                >
                    {matters.length} {matters.length === 1 ? 'Matter' : 'Matters'}
                </span>
            </div>
        );
    }

    const handleNavigateConatct = (id) => {
        Navigate(`/contacts/${id}/`)
    }

    return (
        <>
            <FilterContainer
                show={showFilter}
                onApply={() => refresh()}
                onReset={resetFilters}
            >
                {/* <SelectInput
                            label="Created By"
                            type="users"
                            value={filterData.created_by}
                            onChange={(val) => handleFilterChange('created_by', val)}
                            fetchLookup={fetchLookup}
                            customClass="sm:w-[32%] w-full"
                        /> */}

                <SelectInput
                    isMulti={true}
                    label="Contact Type"
                    type="contact_type"
                    value={filterData.contact_type}
                    onChange={(val) => handleFilterChange('contact_type', val)}
                    loadOptions={loadContactTypeOptions}
                    pageSize={20}
                    customClass="sm:w-[32%] w-full"
                />

                <SelectInput
                    isMulti={true}
                    label="Assigned To"
                    type="users"
                    value={filterData.assigned_to}
                    onChange={(val) => handleFilterChange('assigned_to', val)}
                    loadOptions={loadUserOptions}
                    pageSize={20}
                    customClass="sm:w-[32%] w-full"
                />

                <SelectInput
                    label="Status"
                    value={filterData.status}
                    onChange={(val) => handleFilterChange('status', val)}
                    staticOptions={STATUS_OPTIONS}
                    customClass="sm:w-[32%] w-full"
                />

                <SelectInput
                    label="Secure Messaging"
                    value={filterData.allow_secure_messaging}
                    onChange={(val) => handleFilterChange('allow_secure_messaging', val)}
                    staticOptions={STATUS_NUMBER_OPTIONS}
                    customClass="sm:w-[32%] w-full"
                />

                <SelectInput
                    label="Tags"
                    type="tags"
                    isMulti={true}
                    value={filterData.tags}
                    onChange={(val) => handleFilterChange('tags', val)}
                    loadOptions={loadTagOptions}
                    pageSize={20}
                    customClass="sm:w-[32%] w-full"
                />

                <DateInput
                    customClass="sm:w-[32%] w-full"
                    label="Created At - (From, To)"
                    mode="range"
                    value={filterData.date_range}
                    onChange={(range) => {
                        setFilterData(prev => ({
                            ...prev,
                            from_date: range?.from ?? null,
                            to_date: range?.to ?? null,
                            date_range: range,
                        }));
                    }}
                />

                {/* <TextInput
                    label="State"
                    value={filterData.state}
                    onChange={(val) => handleFilterChange('state', val)}
                    placeholder="Enter state"
                    customClass="sm:w-[32%] w-full"
                />

                <TextInput
                    label="Zip Code"
                    value={filterData.zip}
                    onChange={(val) => handleFilterChange('zip', val)}
                    placeholder="Enter zip"
                    customClass="sm:w-[32%] w-full"
                    type="number"
                /> */}
                {/* <DateFilter
                value={filterData.created_at}
                onChange={(date) =>
                  setFilterData((prev) => ({
                    ...prev,
                    created_at: date,
                  }))
                }
              /> */}
            </FilterContainer>

            <div className="min-w-full mb-4 card">
                <div className="card-header !block">
                    <div className='flex flex-wrap items-center justify-between'>
                        <div className='flex items-center gap-1'>
                            <ColumnToggleDropdown tableRef={tableRef} columns={columns} defaultVisibleColumns={defaultVisibleColumns} />
                            {/* <h3 className="card-title">Contacts</h3> */}
                        </div>

                        <div className='flex flex-wrap items-center gap-2'>
                            <button className='text-xs btn btn-sm btn-primary btn-outline' onClick={handleToggleFilter}>
                                <KeenIcon icon="filter" className="w-fit btn-icon" />
                                {showFilter ? 'Hide Advanced Filters' : 'Advanced Filters'}
                            </button>
                            <div>
                                <Exporter
                                    tableRef={tableRef}
                                    module="contact"
                                    // columns={[]}
                                    columns={columns}
                                    filters={filterData}
                                    needColToExport={true}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <DataTable
                    id="contact-table"
                    ajax={ajaxConfig}
                    columns={columns}
                    options={options}
                    ref={tableRef}
                />
            </div>
        </>
    )
}

export { Contacts }